import { Link } from "react-router-dom"

/**
 * Renders the short customer/vehicle/source-document info attached to a
 * customer_payment ledger row (see AccountTransactionController::attachReferenceContext).
 * Returns null for every other reference_type — nothing else carries this context yet.
 */
const ReferenceContextInfo = ({ referenceType, context }) => {
  if (!context) {
    return null
  }

  if (["employee_bill", "employee_bill_payment", "employee_advance"].includes(referenceType)) {
    const { employee, vehicle, source, purpose } = context

    return (
      <div className="small d-flex flex-column gap-1">
        {employee && (
          <div>
            <span className="fw-semibold">{employee.name}</span>
            {employee.employee_id && <span className="text-muted"> Â· {employee.employee_id}</span>}
          </div>
        )}
        {purpose && <div className="text-muted">{purpose.name || purpose}</div>}
        {vehicle && (
          <div>
            <Link to={`/vehicle-stock-inventory-list/${vehicle.id}/view`}>
              {vehicle.stock_id || vehicle.full_chassis || `Vehicle #${vehicle.id}`}
            </Link>
          </div>
        )}
        {source && <div className="text-muted font-monospace">{source.label || `#${source.id}`}</div>}
      </div>
    )
  }

  if (referenceType !== "customer_payment") {
    return null
  }

  const { customer, vehicle, source } = context

  return (
    <div className="small d-flex flex-column gap-1">
      {customer && (
        <div>
          <Link to={`/customer-list/${customer.cuid || customer.id}/view`}>{customer.name}</Link>
          {customer.mobile && <span className="text-muted"> · {customer.mobile}</span>}
        </div>
      )}
      {vehicle && (
        <div>
          <Link to={`/vehicle-stock-inventory-list/${vehicle.id}/view`}>
            {vehicle.stock_id || vehicle.full_chassis || `Vehicle #${vehicle.id}`}
          </Link>
        </div>
      )}
      {source?.type === "money_receipt" && (
        <div>
          <Link to={`/money-receipts/${source.id}`}>{source.label || `MR #${source.id}`}</Link>
        </div>
      )}
      {source?.type === "standalone" && (
        <span className="text-muted fst-italic">Standalone payment (no source document)</span>
      )}
    </div>
  )
}

export default ReferenceContextInfo
